import $ from 'jquery';
window.$ = window.jQuery = $;
$(document).ready(function() {
    $('#categorylistoptions').select2({
        selectionCssClass:'catedropdown',
        placeholder: 'Type here to search...'
    });
    $('.catedropdown .select2-selection__arrow').append('<button class="btn btn-sm iclr"><i class="fa fa-angle-down text-secondary"></i></button>');
    $('#countrylistoptions').select2({
        selectionCssClass:'countrydropdown',
        placeholder: 'Type here to search...'
    });
    $('.countrydropdown .select2-selection__arrow').append('<button class="btn btn-sm iclr"><i class="fa fa-angle-down text-secondary"></i></button>');
    $('#categorylistoptionshome').select2({
        selectionCssClass:'homedropdown',
        placeholder: 'Type here to search...'
    });
    $('.homedropdown .select2-selection__arrow').append('<i class="fa fa-search"></i>');
    $('#invlistoptions').select2({
        selectionCssClass:'invdropdown',
        placeholder: 'Type here to search...'
    });
    $('.invdropdown .select2-selection__arrow').append('<i class="fa fa-search"></i>');

    $('#bloglistoptions').select2({
        selectionCssClass:'blogdropdown',
        placeholder: 'Type here to search...'
    });
    $('.blogdropdown .select2-selection__arrow').append('<i class="fa fa-angle-down"></i>');
});